import { PkceEnvironmentConfig } from '../types';
import { scopes } from './common';

/**
 * PKCE configuration for UAT environment
 * Applies to: azrc.blackrock.com (pre-production)
 */
export const uatConfig: PkceEnvironmentConfig = Object.freeze({
  clientId: process.env.VITE_CLIENT_ID_PROD || '',
  authorizationUrl: process.env.VITE_AGRAPH_EXTERNAL_PROD_URL + '/api/oauth2/BWN/default/v1/authorize',
  tokenUrl: process.env.VITE_AGRAPH_EXTERNAL_PROD_URL + '/api/oauth2/BWN/default/v1/token',
  providerConfiguration: {
    idp: process.env.VITE_IDP_PROD,
    type: 'okta' as const,
  },
  scope: scopes.join(' '),
  apiBaseUrl: process.env.VITE_AGRAPH_EXTERNAL_PROD_URL || '',
});
